import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { AVATAR_GROUP } from "./constants";
export var en = /*#__PURE__*/_defineProperty({}, AVATAR_GROUP, {
  MEMBERS: 'Members'
});